import styled from 'styled-components'
import { NoPaddingCol } from 'Components/EnhacedFlexboxGrid'

export const _ManageHeader = styled(NoPaddingCol)`
  width: 100%;
  height: 180px;
  background: white;
  position: relative;
  h1 {
    font-family: var(--secondary-font) !important;
  }

  height: ${({ isMobileApp }) => (isMobileApp ? `
      111px;
    ` : '180px;')};

`
